var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"glyph-alternates"},[_c('span',{staticClass:"standard visualized-font",style:({'width': _vm.previewBoxWidth})},[_vm._v("\n    "+_vm._s(_vm._f("unicode")(_vm.glyph))+"\n  ")]),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v("\n    "+_vm._s(_vm.glyph.name)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74ba045b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GlyphAlternatesDisplay.vue
// module id = null
// module chunks = 